/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

/**
 * @nullable
 */
export type CampaignUserUploadStatus = typeof CampaignUserUploadStatus[keyof typeof CampaignUserUploadStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignUserUploadStatus = {
  UPCOMING: 'UPCOMING',
  AVAILABLE: 'AVAILABLE',
  SUBMITTED: 'SUBMITTED',
  EXPIRED: 'EXPIRED',
} as const;
